import { GridRenderCellParams } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import { TableRow, DataRow } from "../types";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CompanyLogo } from "../../../../../components/CompanyLogo";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

export const CompanyNameCell = (params: GridRenderCellParams<TableRow>) => {
  if (params.row.isSkeleton) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
        }}
      >
        <Skeleton variant="rounded" width={24} height={24} />
        <Skeleton variant="text" sx={{ flexGrow: 1 }} />
      </Box>
    );
  }

  const rowData = params.row as DataRow;
  return (
    <Tooltip title={rowData.name || ""} placement="bottom">
      <Stack direction="row" alignItems="center" gap={1} overflow="hidden">
        <CompanyLogo domain={rowData.url} size={24} variant="rounded" />
        <Typography variant="body2" noWrap>
          {rowData.name}
        </Typography>
      </Stack>
    </Tooltip>
  );
};
